<template>
  <basic-container>
    <div class="search_group">
      <el-form ref="form" :model="form" label-width="120px" inline size="small">
        <el-form-item label="手机号：">
          <el-input
            :maxlength="100"
            v-model="form.phone"
            placeholder="手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户uuid：">
          <el-input
            :maxlength="100"
            v-model="form.leboUuid"
            placeholder="用户uuid"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备uid：">
          <el-input
            :maxlength="100"
            v-model="form.sdkUserId"
            placeholder="设备uid"
          ></el-input>
        </el-form-item>
        <el-form-item label="投屏码：">
          <el-input
            :maxlength="100"
            v-model="form.groupNumber"
            placeholder="投屏码"
          ></el-input>
        </el-form-item>
        <el-form-item label="mac地址：">
          <el-input
            :maxlength="100"
            v-model="form.mac"
            placeholder="mac地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="IP地址：">
          <el-input
            :maxlength="100"
            v-model="form.ip"
            placeholder="IP地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="form.searchTime"
            value-format="yyyyMMdd"
            type="daterange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="selectData" type="primary">查询</el-button>
          <el-button @click="form = {}" icon="el-icon-search">清空</el-button>
        </el-form-item>
      </el-form>
      <el-button
        @click="exportList"
        size="small"
        type="primary"
        style="margin-left: 50px"
      >
        导出</el-button
      >
    </div>

    <div class="table" v-loading="listLoading" element-loading-text="加载中">
      <avue-crud
        :option="avueOption"
        :table-loading="loading"
        :data="tableData"
        ref="crud"
        :page.sync="page"
        @on-load="getList"
        @refresh-change="onLoad"
      >
        <template slot-scope="scope" slot="receiverCastServerTimestamp">
          {{ dateFormatFn(new Date(+scope.row.receiverCastServerTimestamp)) }}
        </template>

        <template slot-scope="scope" slot="menu">
          <el-button type="text" @click="showFreeDetailFn(scope.row)"
            >详情</el-button
          >
        </template>
      </avue-crud>
    </div>

    <!-- 展示详情 -->
    <el-dialog
      title="详情"
      :visible.sync="showFreeDetail"
      append-to-body
      width="60%"
    >
      <div class="dialog_box">
        <div class="dialog_title">
          <span>投屏时间</span>
          <span>
            {{
              dateFormatFn(new Date(+dialogData.clientCastLocalTimestamp))
            }}</span
          >
        </div>
        <div class="fole_name">发送端信息</div>
        <ul>
          <li>
            <div class="_row_name">手机号</div>
            <div class="_row_text">{{ dialogData.clientMobilePhone }}</div>
            <div class="_row_name">用户uuid</div>
            <div class="_row_text">{{ dialogData.clientLeboUuid }}</div>
          </li>
          <li>
            <div class="_row_name">设备id（cu）</div>
            <div class="_row_text">{{ dialogData.clientSdkUserId }}</div>
            <div class="_row_name">渠道名称+appid</div>
            <div class="_row_text">{{ dialogData.clientSdkChannelName }}</div>
          </li>
          <li>
            <div class="_row_name">SDK版本</div>
            <div class="_row_text">{{ dialogData.clientSdkVersion }}</div>
            <div class="_row_name">imei</div>
            <div class="_row_text">{{ dialogData.clientImei }}</div>
          </li>
          <li>
            <div class="_row_name">IDFA</div>
            <div class="_row_text">{{ dialogData.clientIdfa }}</div>
            <div class="_row_name">平台类型</div>
            <div class="_row_text">{{ dialogData.clientPlatformType }}</div>
          </li>
          <li>
            <div class="_row_name">设备类型</div>
            <div class="_row_text">{{ dialogData.clientBusinessType }}</div>
            <div class="_row_name">设备品牌</div>
            <div class="_row_text">{{ dialogData.clientDeviceBrand }}</div>
          </li>
          <li>
            <div class="_row_name">设备型号</div>
            <div class="_row_text">{{ dialogData.clientDeviceModel }}</div>
            <div class="_row_name">所在省市</div>
            <div class="_row_text">{{ dialogData.clientIpCode }}</div>
          </li>
          <li>
            <div class="_row_name">IP地址</div>
            <div class="_row_text">{{ dialogData.clientIp }}</div>
            <div class="_row_name">MAC地址</div>
            <div class="_row_text">{{ dialogData.mac }}</div>
          </li>
        </ul>
        <div class="fole_name">接收端信息</div>
        <ul>
          <li>
            <div class="_row_name">手机号</div>
            <div class="_row_text">{{ dialogData.receiverMobilePhone }}</div>
            <div class="_row_name">用户uuid</div>
            <div class="_row_text">{{ dialogData.receiverLeboUuid }}</div>
          </li>
          <li>
            <div class="_row_name">设备id（cu）</div>
            <div class="_row_text">{{ dialogData.receiverSdkUserId }}</div>
            <div class="_row_name">渠道名称+appid</div>
            <div class="_row_text">{{ dialogData.receiverSdkChannelName }}</div>
          </li>
          <li>
            <div class="_row_name">SDK版本</div>
            <div class="_row_text">{{ dialogData.receiverSdkVersion }}</div>
            <div class="_row_name">平台类型</div>
            <div class="_row_text">{{ dialogData.receiverPlatformType }}</div>
          </li>
          <li>
            <div class="_row_name">设备类型</div>
            <div class="_row_text">{{ dialogData.receiverBusinessType }}</div>
            <div class="_row_name">设备品牌</div>
            <div class="_row_text">{{ dialogData.receiverDeviceBrand }}</div>
          </li>
          <li>
            <div class="_row_name">设备型号</div>
            <div class="_row_text">{{ dialogData.receiverDeviceModel }}</div>
            <div class="_row_name">所在省市</div>
            <div class="_row_text">{{ dialogData.receiverIpCode }}</div>
          </li>
          <li>
            <div class="_row_name">IP地址</div>
            <div class="_row_text">{{ dialogData.receiverIp }}</div>
            <div class="_row_name">MAC地址</div>
            <div class="_row_text">{{ dialogData.receiverDeviceMac }}</div>
          </li>
        </ul>
      </div>
    </el-dialog>
  </basic-container>
</template>
<script>
import {
  geSdkusercastfactdetailtList,
  getCount,
} from "@/api/security/screenprojectionLog";
import { exportRecord } from "@/services";
import pagination from "@/util/mixins/pagination";
import OptionLIst from "./screenprojectionLog_Option";
import { dateFormat } from "@/util/date";
export default {
  mixins: [pagination],
  data() {
    return {
      firstLosd:true,
      dialogData: {},
      form: { searchTime: [] },
      tableData: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100,
      },
      avueOption: {},
      listLoading: false,
      showFreeDetail: false,
    };
  },
  created() {
    this.avueOption = OptionLIst;
    this.$nextTick(()=>{
      this.firstLosd = false
    })
  },
  methods: {
    showFreeDetailFn(row) {
      this.dialogData = row;
      this.showFreeDetail = true;
    },
    dateFormatFn(data) {
      return data && dateFormat(data);
    },
    selectData(value) {
      console.log(value);
      this.pageNo = 1;
      this.getList();
    },
    // 重新加载数据
    onLoad() {
      console.log("重新加载数据");
      this.getList();
    },
    // 获取列表
    getList() {
      // 第一次进入页面时不作加载
      if(this.firstLosd)return
      this.listLoading = true;
      let postData = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.form,
      };
      // 时间参数处理
      if (postData.searchTime && postData.searchTime.length) {
        postData.PDateBegin = this.form.searchTime[0] || "";
        postData.PDateEnd = this.form.searchTime[1] || "";
      }
      let onSuccess = (res) => {
        this.listLoading = false;
        const { data, code, msg } = res.data;
        if (code === 200) {
          this.tableData = data.records;
          this.page.total = data.total;
          this.totalEl = data.total;
        } else {
          this.$message.error(msg);
        }
      };
      geSdkusercastfactdetailtList(postData)
        .then(onSuccess)
        .catch(() => {
          this.listLoading = false;
        });
    },
    // 导出
    async exportList() {
      // 导出数据前，查询一下数量，如果数据大于 5000 条时，提示“无法导出，超数量限制”
      let postData = {
        ...this.form,
      };
      // 时间参数处理
      if (postData.searchTime && postData.searchTime.length) {
        postData.PDateBegin = this.form.searchTime[0] || "";
        postData.PDateEnd = this.form.searchTime[1] || "";
      }
      let res = await getCount(postData);
      if (res.data.data > 5000) {
        this.$message({ message: "无法导出，超数量限制", type: "warning" });
        return;
      }
      exportRecord(postData);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog_box {
  padding: 0 20px;
  .dialog_title,
  .fole_name {
    color: rgba(16, 16, 16, 1);
    font-size: 18px;
    margin-bottom: 30px;
  }
  .dialog_title > span {
    margin-right: 30px;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0 0 30px;
    li {
      display: flex;
      justify-content: space-between;
      border: 1px solid #ccc;
      ._row_name {
        width: 15%;
        background-color: #e8e6e6;
        font-weight: bold;
        padding: 15px;
      }
      ._row_text {
        width: 35%;
        padding: 15px;
      }
    }
  }
}
</style>
